// extracted by mini-css-extract-plugin
export var cardTitle = "_ja-1";
export var commentBubble = "_ja-e";
export var commentForm = "_ja-a";
export var commentInput = "_ja-b";
export var commentLabel = "_ja-d";
export var commentPrompt = "_ja-9";
export var csatCard = "_ja-0";
export var feedbackSection = "_ja-7";
export var starDisabled = "_ja-6";
export var starEmpty = "_ja-5";
export var starFilled = "_ja-4";
export var starWrapper = "_ja-3";
export var starsContainer = "_ja-2";
export var submittedComment = "_ja-c";
export var thankYouText = "_ja-8";